import { Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import globalUseStyles from '../../styles/globalCustomStyles';

const ChooseDaysOfWeekButton = (props) => {
    const t = useTranslate();
    const globalClasses = globalUseStyles();
    const daysOfWeek = props.daysOfWeek;
    const setDaysOfWeek = props.setDaysOfWeek;

    const handleDayChange = (event) => {
        setDaysOfWeek({
            ...daysOfWeek,
            [event.target.name]: event.target.checked,
        });
    };

    return (
        <div>
            <Typography variant="h9" style={{ marginRight: '10px' }}>{t('resources.global.chooseDaysTitle')}</Typography>
            <FormGroup row>
                {Object.keys(daysOfWeek).map((day) => (
                    <FormControlLabel
                        key={day}
                        control={
                            <Checkbox
                                checked={daysOfWeek[day]}
                                onChange={handleDayChange}
                                name={day}
                            />
                        }
                        label={
                            <Typography variant="h9">
                                {t(`resources.days.${day}`)}
                            </Typography>
                        }
                        className={globalClasses.dayCheckbox}
                    />
                ))}
            </FormGroup>
        </div>
    );
};

export default ChooseDaysOfWeekButton;